import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomogenizationOrderOutlineAddPage } from './homogenization-order-outline-add';
import { DatePickerModule } from 'ion-datepicker';
import { MomentModule } from 'angular2-moment/moment.module';

@NgModule({
    declarations: [
        HomogenizationOrderOutlineAddPage,
    ],
    imports: [
        IonicPageModule.forChild(HomogenizationOrderOutlineAddPage),
        DatePickerModule,
        MomentModule
    ],
})
export class HomogenizationOrderOutLineAddPageModule { }


// WEBPACK FOOTER //
// ./src/pages/homogenization-order-outline-add/homogenization-order-outline-add.module.ts